export default __webpack_public_path__ + "static/media/mobile-logo.e4492339.svg";